import { DisaggregatedMetric, GeoDetails, GeoTag } from "../../services/types";

interface TitleBannerProps {
    metric: DisaggregatedMetric | null;
    geoDetails: GeoDetails[];
    geoTag: GeoTag | null;
    svg: string;
    text: string;
}
  
const TitleBanner = ({ metric, svg, text }: TitleBannerProps) => {
    // Destructure metric properties
    const name = metric?.name ?? "Selected Index";

    return (
    <>
        <div className="border bg-port-blue rounded-md py-2 flex items-center justify-between px-4">
            <div className="flex items-center">
                <img src={svg} alt={name} className="max-w-8 max-h-7"/>
                <h2 className="font-bold text-white ml-2">{text}</h2>
            </div>
        </div>
    </>  
    );
};
  
export default TitleBanner;